import { BaseMapper } from '@/core/mapper';

import { Vendor } from '@/core/vendor';
import { AccessRequest } from '@/core/access-request';

const schema = {
  first_name: {
    label: 'First name',
    parseFrom: 'attributes.first_name',
  },
  last_name: {
    label: 'Last name',
    parseFrom: 'attributes.last_name',
  },
  full_name: {
    parseFrom: 'meta.full_name',
    omitFromRequest: true,
  },
  job_title: {
    label: 'Job title',
    parseFrom: 'attributes.job_title',
  },
  department: {
    label: 'Department',
    parseFrom: 'attributes.department',
  },
  email: {
    label: 'Email',
    parseFrom: 'attributes.email',
    toRequest: entity => ({
      email: entity.email || entity.user_email,
    }),
  },
  phone_number: {
    label: 'Phone number',
    parseFrom: 'attributes.phone_number',
  },
  role: {
    label: 'Role',
    parseFrom: 'attributes.roles[0]',
    omitFromRequest: true,
  },
  roles: {
    type: 'array',
    parseFrom: 'attributes.roles',
    toRequest: entity => ({
      role_uuids: (_.get(entity, 'roles', [])).map(role => role.uuid),
    }),
  },
  status: {
    label: 'Status',
    parseFrom: 'meta.current_state',
    omitFromRequest: true,
  },
  confirmed: {
    parseFrom: 'attributes.confirmed',
    omitFromRequest: true,
  },
  send_notifications: {
    label: 'Send notification',
    parseFrom: 'attributes.send_notifications',
  },
  vendor: {
    fromResponse: (entity) => {
      const vendor = _.get(entity, 'relationships.vendor');
      return vendor && new Vendor(vendor);
    },
    omitFromRequest: true,
  },
  worker: {
    parseFrom: 'relationships.worker.attributes',
    omitFromRequest: true,
  },
  user_type: {
    parseFrom: 'attributes.user_type',
    omitFromRequest: true,
  },
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  access_requests: {
    fromResponse: entity => _.get(entity, 'relationships.access_requests', []).map(accessRequest => new AccessRequest(accessRequest)),
    omitFromRequest: true,
  },
  audits: {
    parseFrom: 'metadata.audits',
    omitFromRequest: true,
  },
};

class VendorUser extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

VendorUser.schema = schema;

export default VendorUser;
